var loadProductRecommendationsIntoBlock = function() {
    // Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector("#related-products-block");
    if (productRecommendationsSection === null) { return; }
    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open("GET", productRecommendationsSection.dataset.url);
    request.onload = function() {
        if (request.status >= 200 && request.status < 300) {
            var container = document.createElement("div");
            container.innerHTML = request.response;
            productRecommendationsSection.innerHTML = container.querySelector("#related-products-block").innerHTML;
            theme.ProductBlockManager.loadImages(productRecommendationsSection);
            theme.initAnimateOnScroll();
        }
    };
    request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
    if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"]#related-products-block')) {
        loadProductRecommendationsIntoBlock();
    }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoBlock();


(function () {
    jQuery(window).on('cc-variant-updated', function (event, data) {
        if(data?.variant?.id){
            let variant_id = data.variant.id;
            jQuery('input.shelf-location-input').prop('disabled', true);
            jQuery(`input.shelf-location-input[data-variant-id="${variant_id}"]`).prop('disabled', false);
        }
    })
})();


(function () {
    if(!jQuery('.fixed-buy-button').length)
        return;

    let headerHeight = jQuery('#shopify-section-header').outerHeight();

    jQuery('.fixed-buy-button .deploy-variants').on('click', function (){
        jQuery('.fixed-buy-button .deploy-variants').fadeOut(400, function (){
            jQuery('.fixed-buy-button .cta-variants-wrapper').fadeIn();
        });

    })

    let resetButtonState = function (){
        jQuery('.fixed-buy-button').LoadingOverlay('hide');
        jQuery('.fixed-buy-button .cta-variants-wrapper').fadeOut(400, function (){
            jQuery('.fixed-buy-button .deploy-variants').fadeIn();
        });
        jQuery(document).off({ajaxComplete: resetButtonState})
    }

    jQuery('a.submit-link').on('click', function (event){
        event.preventDefault();
        if (jQuery(this).closest('form').hasClass('disabled'))
            return false;
        else {
            jQuery('.fixed-buy-button').LoadingOverlay('show');
            jQuery(document).on('ajaxComplete', resetButtonState)
            jQuery(this).closest('form').submit();
        }
    })

    let buttonHidden = true;
    jQuery(window).on('scroll', function () {
        let buyButton = jQuery('form.product-purchase-form:not(.fixed-cta) button[type="submit"]')
        if(!buyButton.length)
            buyButton = jQuery('form.product-purchase-form:not(.fixed-cta) .product-unavailable');

        let elementTop = buyButton.offset().top;
        let elementBottom = elementTop - headerHeight + buyButton.outerHeight();

        let viewportTop = jQuery(window).scrollTop();
        let viewportBottom = viewportTop + jQuery(window).height();

        if ((elementBottom > viewportTop && elementTop < viewportBottom) || (viewportTop + jQuery(window).height() > jQuery(document).height() - 150)) {
            if (!buttonHidden) {
                jQuery('.fixed-buy-button').fadeOut(400, "linear");
                resetButtonState();
                buttonHidden = true
            }
        } else if (jQuery(window).width() < 768 && buttonHidden) {
            jQuery('.fixed-buy-button').fadeIn(400, "linear");
            buttonHidden = false
        }
    })
})();